(function(){
  const sections = document.querySelectorAll('.evidence-tabs');
  if(!sections.length) return;

  sections.forEach(section => {
    const tablist = section.querySelector('.evidence-tabs__tablist');
    const tabs = Array.from(section.querySelectorAll('.evidence-tabs__tab'));
    const panels = Array.from(section.querySelectorAll('.evidence-tabs__panel'));

    function activate(index){
      tabs.forEach((tab, i) => {
        const panelId = tab.getAttribute('data-panel');
        const panel = section.querySelector('#' + panelId);
        const active = i === index;

        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');

        if(panel){
          if(active){ panel.removeAttribute('hidden'); panel.classList.add('is-active'); }
          else { panel.setAttribute('hidden', ''); panel.classList.remove('is-active'); }
        }
      });
      tabs[index].focus();
    }

    // Click
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => activate(i));
    });

    // Keyboard (Left/Right/Home/End)
    tablist.addEventListener('keydown', (e) => {
      const current = tabs.findIndex(t => t.getAttribute('aria-selected') === 'true');
      let next = current;
      switch(e.key){
        case 'ArrowRight': next = (current + 1) % tabs.length; break;
        case 'ArrowLeft':  next = (current - 1 + tabs.length) % tabs.length; break;
        case 'Home':       next = 0; break;
        case 'End':        next = tabs.length - 1; break;
        default: return;
      }
      e.preventDefault();
      activate(next);
    });
  });
})();
